import React from "react";
import { Button } from "@/components/ui/button";
import { Home, Search, User } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

interface NavigationBarProps {
  className?: string;
}

const NavigationBar = ({ className = "" }: NavigationBarProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const getButtonStyle = (path: string) => {
    if (location.pathname === path) {
      return "text-[#735fe2]";
    }
    return "text-gray-600 hover:text-[#735fe2]";
  };

  return (
    <div
      className={`w-full h-14 bg-white/0 backdrop-blur-md border-t border-white/50 flex items-center justify-between px-8 ${className}`}
    >
      <Button
        variant="link"
        size="icon"
        className={`h-9 w-9 ${getButtonStyle("/")} hover:bg-transparent`}
        onClick={() => navigate("/")}
      >
        <Home className="h-[22px] w-[22px]" />
      </Button>

      <Button
        variant="link"
        size="icon"
        className={`h-9 w-9 ${getButtonStyle("/search")} hover:bg-transparent`}
        onClick={() => navigate("/search")}
      >
        <Search className="h-[22px] w-[22px]" />
      </Button>

      <Button
        variant="link"
        size="icon"
        className={`h-9 w-9 ${getButtonStyle("/profile")} hover:bg-transparent`}
        onClick={() => navigate(user ? "/profile" : "/login")}
      >
        <User className="h-[22px] w-[22px]" />
      </Button>
    </div>
  );
};

export default NavigationBar;
